module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Hat-824b4887d971ac7d2974c61dac776f14.svg";